module.exports = __webpack_public_path__ + "static/media/microsoft-word.113ac212.svg";